import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { leagueEventStore } from 'state/league/leagueEvent'
import RequiredDetailsModal from 'pages/Events/Views/Common/Modals/RequiredDetails'

const MandatoryInfo: React.FC = () => {
  const [requiredDetailsModal, setRequiredDetailsModal] =
    useState<boolean>(false)
  const [isAdded, setIsAdded] = useState<boolean>(false)
  const { requiredDetails, setRequiredDetails } = leagueEventStore(store => ({
    requiredDetails: store.requiredDetails,
    setRequiredDetails: store.setRequiredDetails,
  }))

  console.log(requiredDetails, 'this is required details....')

  useEffect(() => {
    const hasSelected = Object.keys(requiredDetails).some(category =>
      requiredDetails[category].some(item => item.value === true),
    )
    setIsAdded(hasSelected)
  }, [requiredDetails])

  return (
    <>
      <div onClick={() => setRequiredDetailsModal(true)}>
        <IconsTextNavigation
          iconName="Info"
          heading="Mandatory Information"
          isCompleted={isAdded}
        />
      </div>
      {requiredDetailsModal && (
        <RequiredDetailsModal
          openModal={requiredDetailsModal}
          closeModal={setRequiredDetailsModal}
          requiredDetails={requiredDetails}
          setRequiredDetails={setRequiredDetails}
        />
      )}
    </>
  )
}

export default MandatoryInfo
